<template>
  <v-container fluid class="itemsubcategory-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/itemsubcategory/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="itemsubcategories-table"
              show-select
              single-select
              item-key="_id"
              sort-by="itemsubcategoryname"
              :footer-props="footer"
              :headers="headers"
              :items="itemsubcategories"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Item Category?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteItemSubcategory.itemsubcategoryname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteItemSubcategory)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.itemsubcategoryimage" size="35">
                  <img v-bind:src="item.itemsubcategoryimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.itemsubcategoryname[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.itemsubcategoryname="{ item }">
                <a class="primaryConst--text">{{ item.itemsubcategoryname }}</a>
              </template>
              <template v-slot:item.itemcategoryid="{ item }">
                {{ 
                  item.itemcategoryid !== null ? itemcategories.find(itemcategory=>itemcategory._id == item.itemcategoryid)['itemcategoryname'] : ''
                 }}
              </template>
              <template v-slot:item.company>
                Flatlogic
              </template>
              <template v-slot:item.itemsubcategorystatus="{ item }">
                <v-chip
                  :color="!item.itemsubcategorystatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.itemsubcategorystatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mock from "./mock"
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'itemsubcategoryList',
  data() {
    return {
      mock,
      config,
      snackbar: null,
      dialog: false,
      deleteItemSubcategory: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Group', value: 'itemcategoryid' },
        { text: 'Name', value: 'itemsubcategoryname' },
        { text: 'Code', value: 'itemsubcategorycode' },
        { text: 'Status', value: 'itemsubcategorystatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
    }
  },

  computed: {
    ...mapState('ItemSubcategory', ['itemsubcategories', 'isReceiving', 'isDeleting', 'idToDelete', 'itemsubcategoriesMessage', 'isUpdating']),
    ...mapState('ItemCategory', ['itemcategories']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit itemsubcategory'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    itemsubcategoriesMessage() {
      this.notification = this.itemsubcategoriesMessage;
      this.addSuccessNotification()
    }
  },
  async created () {
    if(this.itemcategories.length==0) await this.getItemCategoriesRequest();
  },

  methods: {
    ...mapActions('ItemSubcategory', ["getItemSubcategoriesRequest","deleteItemSubcategoryRequest","updateItemSubcategoryRequest","createItemSubcategoryRequest"]),
    ...mapActions('ItemCategory', ["getItemCategoriesRequest"]),
    editItem(item) {
      this.$router.push({ name: 'ItemSubcategoryEdit', params: item })
    },

    deleteItem(item) {
      this.deleteItemSubcategoryRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteItemSubcategory = {
        _id: item._id,
        itemsubcategoryname: item.itemsubcategoryname,
      }
    },
    close () {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
      })
    },


    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
